import React, { useState } from "react";
import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Personal_Report_Filter from "./personal_report_filter/Personal_Report_Filter";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Personal_Report_Table from "./personal_report_table/Personal_Report_Table";

const Personal_Report = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <Personal_Report_Filter setShow={setShow} />
      </div>

      <div className="report_table_div">
        <Personal_Report_Table />
      </div>

      <Common_Report_Offcanvas
        title={"Personal Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Personal_Report;
